import React, { useState, useEffect } from 'react';
import { Alert } from '@aws-amplify/ui-react';

import './StackPanel.css';
import { TabPanelUnstyled } from '@mui/base';
import { panelStyle } from './StackPanelUtil';

// https://reactjs.org/docs/react-api.html#cloneelement
// https://beta.reactjs.org/reference/react/cloneElement
// https://beta.reactjs.org/reference/react/cloneElement#alternatives

const StackPanel = ({
  name,
  direction,            // l2r, r2l, t2b, b2t
  anchor,               // left, right, bottom, top, tl, tr, bl, br
  fillParent,           // expand this element to fill available space in parent element
  growLastChild,        // true, false
  alignItems,           // left, center, right, stretch, baseline | top, center, bottom, stretch, baseline
  justifyContent,       // flex-start | flex-end | center | space-between | space-around | space-evenly | start | end | left | right ... + safe | unsafe;

  gap,
  children,

  bg,
  addStyle,

  position,  // hack.. figure out how to get rid of this..
}) => {
  const style = panelStyle(direction, anchor, fillParent, growLastChild, alignItems, justifyContent, gap, addStyle, bg, position);

  // https://stackoverflow.com/questions/66825585/styling-the-last-child-of-a-react-list
  // https://stackoverflow.com/questions/30533171/react-js-conditionally-applying-class-attributes
  const cname = `stack-panel ${growLastChild ? 'stack-panel-grow-last' : ''}`;

  return (
    <div className={cname} x-name={name} style={style}>
      {children}
    </div>
  );
}

export default StackPanel;
